import React from "react";
import { Tag, Flex } from "antd";

const EntityTagSelector = ({ value = [], onChange, options = [] }) => {

    const allOption = options.find((opt) => opt.label === "All");
    const otherOptions = options.filter((opt) => opt.label !== "All");

    const toggleTag = (tagValue) => {
        let newSelected = [...value];

        // If ALL clicked
        if (tagValue === allOption?.value) {
            if (value.includes(allOption.value)) {
                newSelected = [];
            } else {
                newSelected = options.map((opt) => opt.value);
            }
        } else {
            if (value.includes(tagValue)) {
                newSelected = value.filter((v) => v !== tagValue);
            } else {
                newSelected = [...value, tagValue];
            }

            // remove ALL if present
            newSelected = newSelected.filter((v) => v !== allOption?.value);

            // auto-select ALL if all others selected
            const allOthersSelected = otherOptions.every((opt) =>
                newSelected.includes(opt.value)
            );

            if (allOthersSelected && allOption) {
                newSelected = options.map((opt) => opt.value);
            }
        }

        onChange?.(newSelected);
    };

    return (
        <Flex wrap="wrap" gap={8}>
            {options.map((opt) => {
                const isActive = value.includes(opt.value);

                return (
                    <Tag
                        key={opt.value}
                        onClick={() => toggleTag(opt.value)}
                        className={`entity-tag ${isActive ? "active" : ""}`}
                    >
                        {opt.label}
                    </Tag>
                );
            })}
        </Flex>
    );
};

export default EntityTagSelector;